import { jsxs as U, jsx as r } from "react/jsx-runtime";
import { memo as W, useCallback as h, useMemo as f } from "react";
import { Col as k, Select as C } from "antd";
import { u } from "../../styled-components.browser.esm-BFmoFexH.js";
import { getIndexFromID as S, isEmpty as y } from "@biron-data/react-components";
import { SortableRowWithDefaultValue as E, ColWithLeftMargin as b } from "../utils.js";
import V from "../../description/DimensionDescription.js";
import { useLanguageResolver as q } from "@biron-data/react-contexts";
import { SlicerTarget as L } from "../../configuration/types.js";
import { useColumnLayout as m } from "../metrics/hooks.js";
import { useSelectorLayout as z } from "../../layout/useSelectorLayout.js";
const oe = W(function({
  id: i,
  value: a,
  disabled: $,
  availableDimensions: d,
  canRemove: v,
  onSelect: w,
  onDelete: l,
  options: M,
  getPopupContainer: P,
  configuration: t,
  isDefault: j,
  getMoreInformationLink: x
}) {
  const n = q(), o = z(), F = h(
    (e) => {
      e || l == null || l(S(i));
    },
    [i, l]
  ), O = h((e, c) => {
    if (!t || y(e) || t.slicerTargets === void 0)
      return "";
    const s = e == null ? void 0 : e[c < t.slicerTargets.length ? c : t.slicerTargets.length - 1];
    switch (s) {
      case L.COLUMN:
        return `${n.get(`configuration-slicer-target.${L.COLUMN}`)} ${c + 1}`;
      default:
        return y(s) ? "" : n.get(`configuration-slicer-target.${s}`);
    }
  }, [t, n]), T = `${n.get("configuration-add-slicer")} ...`, g = f(() => d.find((e) => e.code === a), [d, a]), I = m(o, "auto", 14), N = m(o, "none", 1), R = m(o, "none"), p = f(() => o === "default" ? 5 : 0, [o]);
  return /* @__PURE__ */ U(E, { $isdefault: j ? 1 : 0, children: [
    /* @__PURE__ */ r(k, { ...I, children: /* @__PURE__ */ r(B, { value: a ?? null, disabled: $, placeholder: T, showSearch: !0, allowClear: v, optionFilterProp: "children", onChange: F, onSelect: w, virtual: !1, getPopupContainer: P, optionLabelProp: "label", children: M.map((e) => /* @__PURE__ */ r(
      C.Option,
      {
        disabled: e.disabled,
        label: e.selectorLabel,
        children: e.label
      },
      e.value
    )) }) }),
    /* @__PURE__ */ r(D, { $value: p, ...N, children: g && /* @__PURE__ */ r(V, { dimension: g, getMoreInformationLink: x }) }),
    /* @__PURE__ */ r(b, { $value: p, ...R, children: /* @__PURE__ */ r(A, { children: t && O(t.slicerTargets, S(i)) }) })
  ] });
}), A = u.div`
    color: var(--light-grey);
    height: 100%;
    align-content: center;
`, B = u(C)`
    width: 100%;
`, D = u(b)`
    align-content: center;
    align-items: center;
    display: flex;
    justify-content: center;
`;
export {
  oe as default
};
//# sourceMappingURL=SingleSlicerSelector.js.map
